import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SortDirection } from 'src/@smartmanufacturing/common/enum';
import { Plant, PlantDetail } from 'src/app/user-management/plant-setup/models/plant';
import { DataMapper } from 'src/app/user-management/shared/models/data-mapper';

import { BaseApi } from 'src/backend/api/base-api';

@Injectable({
    providedIn: 'root'
})
export class PlantService {

    constructor(private http: HttpClient, private baseApi: BaseApi) { }

    getLazyLoadedPlantsByGroup(data: any, grpId: number): Observable<DataMapper<Plant>> {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.orgStatus) {
            if (params.length > 0) {
                params += '&';
            }
            params += `status=` + data?.orgStatus;
        }
        if (data?.sortDirection !== SortDirection.None) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortDirection=' + data?.sortDirection;
        }
        if (data?.sortField) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortField=' + data?.sortField;
        }
        if (data?.searchValue) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'phrase=' + data?.searchValue;
        }
        return this.http.get<DataMapper<Plant>>(this.baseApi.encodeURL(Constants.API_PLANTS_LAZYLOADED_BYGROUP + '/' + grpId + '?' + params));
    }

    getAllPlantsByGroup(grpId: number): Observable<DataMapper<Plant>> {
        return this.http.get<DataMapper<Plant>>(this.baseApi.encodeURL(Constants.API_PLANTS_GETALL_BYGROUP + '/' + grpId));
    }

    getPlantById(plantCode: string): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_PLANT_BY_ID + '/' + plantCode));
    }

    createPlant(data: any): Observable<any> {
        return this.http.post<any>(this.baseApi.encodeURL(Constants.API_PLANT_CREATE), data);
    }

    activatePlant(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_PLANT_ACTIVATE + '/' + id));
    }
    deactivatePlant(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_PLANT_DEACTIVATE + '/' + id));
    }

    editPlant(data: any): Observable<any> {
        return this.http.post<any>(this.baseApi.encodeURL(Constants.API_PLANT_EDIT), data);
    }
    getPlantDetails(code: string): Observable<PlantDetail> {
        return this.http.get<PlantDetail>(this.baseApi.encodeURL(Constants.API_PLANT_DETAILS + '/' + code));
    }
    getCurrencyDetails(): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_CURRENCY_DETAILS));
    }

}
